<template>
  <div class="cms-divider-block">
    <div v-if="block.title" class="cms-divider-labeled">
      <span class="cms-divider-line"></span>
      <span class="cms-divider-title">{{ block.title }}</span>
      <span class="cms-divider-line"></span>
    </div>
    <hr v-else class="cms-divider-line-only" />
  </div>
</template>

<script>
export default {
  name: 'DividerBlock',
  props: {
    block: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.cms-divider-block {
  width: 100%;
  padding: 8px 0;
}

.cms-divider-labeled {
  display: flex;
  align-items: center;
  gap: 16px;
}

.cms-divider-line {
  flex: 1;
  height: 1px;
  background: var(--border);
}

.cms-divider-title {
  flex-shrink: 0;
  color: var(--subtle);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.cms-divider-line-only {
  margin: 0;
  border: 0;
  border-top: 1px solid var(--border);
}
</style>
